var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"},on:{"click":function($event){$event.preventDefault();return _vm.skipToMain($event)}}},[_vm._v(" Preskočiť na hlavný obsah ")])}
var staticRenderFns = []

export { render, staticRenderFns }